import React from 'react';
import { BadgeCheckIcon, InstagramIcon, StoreIcon, TruckIcon } from 'lucide-react';
import { Section } from './Section';
const POINTS = [{
  icon: StoreIcon,
  title: 'Tienda real de productos Apple',
  description: 'iPhone, iPad y MacBook con local en CABA, Saavedra, y años de operación.'
}, {
  icon: BadgeCheckIcon,
  title: 'Comunidad Apple en Argentina',
  description: 'Miles de clientes acompañados en la compra y el uso de sus equipos.'
}, {
  icon: TruckIcon,
  title: 'Garantía oficial y envíos a todo el país',
  description: 'La misma seriedad con la que vendemos equipos está detrás de esta guía.'
}];
export function BackedBy() {
  return <Section className="bg-ink-950" innerClassName="max-w-5xl" data-id="element-38" data-mp="1kpylq2l3q29r">
      <div className="grid items-center gap-10 lg:grid-cols-[0.85fr_1.15fr]" data-id="element-39" data-mp="4chztx8scgv9">
        <img src="https://cdn.magicpatterns.com/uploads/wYQCjgyfnCBm4ETfVvosu5/img_cns_5.jpg" alt="Perfil de Instagram de Celulares Nuevos Saavedra con 180 mil seguidores" className="mx-auto w-full max-w-xs rounded-3xl border border-white/10 object-cover" data-id="element-40" data-mp="4emdv80eew99" />

        <div data-id="element-41" data-mp="39jxt2b7bvfxt">
          <p className="mb-3 text-xs font-semibold uppercase tracking-[0.22em] text-gold" data-id="element-42" data-mp="39k7fxpx2t6za">
            Respaldo
          </p>
          <h2 className="text-3xl font-extrabold leading-[1.15] tracking-tight text-white sm:text-4xl" data-id="element-43" data-mp="3ii1d132o04ni">
            Esta página está respaldada por Celulares Nuevos Saavedra
          </h2>
          <p className="mt-5 text-base leading-relaxed text-white/65 sm:text-lg" data-id="element-44" data-mp="3sgywhrl8h7zn">
            No es un curso anónimo de internet. Detrás de esta guía hay una
            tienda real de venta de productos Apple, con más de 180.000
            seguidores en Instagram y clientes en todo el país.
          </p>

          <ul className="mt-8 space-y-3" data-id="element-45" data-mp="k0dyf5u53zbb">
            {POINTS.map(({
            icon: Icon,
            title,
            description
          }) => <li key={title} className="flex items-start gap-4 rounded-3xl border border-white/8 bg-ink-900 p-5" data-id="element-46" data-mp="f2lxjmbip2uz">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-2xl bg-gold/15" data-id="element-47" data-mp="3cvdtmq2xba55">
                  <Icon className="h-5 w-5 text-gold" aria-hidden="true" data-id="element-48" data-mp="3huqpg0brvrjv" />
                </span>
                <div data-id="element-49" data-mp="3mkxd9xygn812">
                  <p className="text-sm font-bold text-white sm:text-base" data-id="element-50" data-mp="3mlgt994jvmcg">
                    {title}
                  </p>
                  <p className="mt-1 text-xs leading-relaxed text-white/55 sm:text-sm" data-id="element-51" data-mp="3rjs51peeo6xb">
                    {description}
                  </p>
                </div>
              </li>)}
          </ul>

          <a href="https://instagram.com/celularesnuevossaavedra" target="_blank" rel="noopener noreferrer" className="mt-6 inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-5 py-3 text-sm font-semibold text-white transition-colors duration-200 hover:bg-white/10 focus:outline-none focus-visible:ring-2 focus-visible:ring-accent" data-id="element-52" data-mp="4gdk9dbgqq6r">
            <InstagramIcon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-53" data-mp="23oc4c6189cvn" />
            Ver el perfil @celularesnuevossaavedra
          </a>
        </div>
      </div>
    </Section>;
}